let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cFmpd")).then(() => parcelRequire('htw0K'));